import React,{useEffect,useState} from "react";
import {Link} from "react-router-dom";
import {api} from "@/lib/api";

// One availability request shared by all the visible PC cards.
let cached = null;
let cachedAt = 0;
function eligibleStockPcIds(){
  const now = Date.now();
  if (!cached || now - cachedAt > 1000) {
    cachedAt = now;
    cached = api.get("/stock/eligible-pcs")
      .then(r=>new Set(r.data?.eligible_pc_ids || []))
      .catch(e=>{cached=null;throw e;});
  }
  return cached;
}

export default function StockAttachButton({pc,btn}){
  const [eligible,setEligible] = useState(false);
  const blocked = !pc || pc.pc_purpose === "depot_stock" ||
    String(pc.price_details||"").trim().toUpperCase() === "STOCK" ||
    !!pc.stock_unit_id || Number(pc.quantity||1) !== 1;
  useEffect(()=>{
    if (blocked) {setEligible(false);return;}
    let active = true;
    eligibleStockPcIds().then(ids=>{if(active)setEligible(ids.has(pc.id));})
      .catch(()=>{if(active)setEligible(false);});
    return ()=>{active=false;};
  },[pc?.id,pc?.stock_unit_id,pc?.quantity,pc?.container_type,blocked]);
  if (blocked || !eligible) return null;
  return <Link to={"/pcs/allocate-stock/"+encodeURIComponent(pc.id)}
    className={btn} title="Link a matching Kerala Depot Stock container to this PC">
    Attach Stock
  </Link>;
}
